import React from 'react';
import { Breadcrumb, Typography, Layout } from 'antd';
import { Link } from 'react-router-dom';

const { Title } = Typography;
const { Content } = Layout;

const BackHome = ({ title, product, link, sub, t }) => {
    return (
        <Layout style={{ background: '#f3f3f3', padding: '25px 0' }}>
            <Content style={{ textAlign: 'center' }}>
                <p className='text-uppercase' level={2} style={{ color: '#119811', marginBottom: '10px', fontWeight: 800, fontSize:"2rem" }}>
                    {title}
                </p>
                <Breadcrumb separator=">" style={{ justifyContent: 'center', display: 'flex' }}>
                    <Breadcrumb.Item className='footer-content'>
                        <Link to="/" key="/" className={`footer-submenuNew`}>{t("Home")}</Link>
                    </Breadcrumb.Item>
                    {
                        sub ?
                            <Breadcrumb.Item className='footer-content'>
                                <Link to={link} key="/" className={`footer-submenuNew`}>{sub}</Link>
                            </Breadcrumb.Item> : ""
                    }
                    <Breadcrumb.Item><span style={{ color: '#119811' }}>{product ? product : title}</span></Breadcrumb.Item>
                </Breadcrumb>
            </Content>
        </Layout>
    );
};

export default BackHome;

